/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Status_AuthenticationInputs */



/**
* | output |
* | --- |
* | "Authentication" |
*
* @param {Offline_Status_AuthenticationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_status_authentication = /** @type {((inputs?: Offline_Status_AuthenticationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Status_AuthenticationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Authentification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Authentifizierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autenticazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аутентификация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Autenticación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("验证")
	if (locale === "ja") return /** @type {LocalizedString} */ ("認証")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रमाणीकरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Autenticação")
	return /** @type {LocalizedString} */ ("Authentication")
});